module.exports = __webpack_public_path__ + "img/img-1.a9b1b2a3.png";